import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SelfLearnService } from 'projects/selflearnv2-ui/src/app/services/self-learn/self-learn.service';
import {
  ApexChart,
  ApexResponsive,
} from 'ng-apexcharts';


export type DonutChartOptions1 = {
  series: any;
  chart: ApexChart;
  responsive: ApexResponsive[];
  labels: any;
  plotOptions: any;
  colors: any;
  legend: any;
  xaxis: any;
  yaxis: any;
  fill: any;
  dataLabels: any;
  tooltip: any;
  stroke: any;
  states: any;
  title: any;
};

@Component({
  selector: 'app-parctice-completion',
  templateUrl: './parctice-completion.component.html',
  styleUrls: ['./parctice-completion.component.css']
})
export class ParcticeCompletionComponent implements OnInit {

  public donutchartOptions1: Partial<DonutChartOptions1>;
  practiceAnalysis:any;
  tabPracticeTopicData:any = [];
  constructor(public router: Router, public selfLearnService:SelfLearnService) { }

  ngOnInit(): void {
    this.getPracticeAnalysis()
    this.getTopicsByChapterExamSubtenant();
  }

  navigateToChapterPractice(){
    this.router.navigateByUrl("selfLearn-V2/chapter");
  }

  getPracticeAnalysis(){
    this.selfLearnService.getPracticeAnalysis().subscribe((resp:any) => {
      this.practiceAnalysis = {...resp?.data};
      this.renderDonutChart()
    })
  }

  getTopicName(){
    return this.selfLearnService.getTopicName();
  }

  goToNextTopic(){
    this.navigateToPracticeQuestions()
  }

  getTopicsByChapterExamSubtenant(){
    this.selfLearnService.getTopicsByChapterExamSubtenant().subscribe((resp:any) => {
      this.tabPracticeTopicData = resp?.data;
      this.getPracticeProgress();
    })
  }

  getPracticeProgress(){
    this.selfLearnService.getPracticeProgress().subscribe((resp:any) => {
      if(resp?.data == null) return;
      this.tabPracticeTopicData = this.tabPracticeTopicData.map((item:any, row:any) => {
      let found = resp?.data?.find((element:any) => item.topicId == element.topicId);
      if(!found){found = {};found['levelsInProgress'] = found['levelsCompleted'] = 0}
        return {...item, ...found};
      });
      console.log(this.tabPracticeTopicData);
    })
  }

  setTopicAndNavigateToPracticeQuestions(){
    const currentTopicId = this.selfLearnService.getTopicId();
    let nextTopic;
    const selectedTopic = this.tabPracticeTopicData.map((topic:any,row:any) => {
    nextTopic = this.tabPracticeTopicData[row+1]
      if(topic.topicId == currentTopicId && nextTopic.levelsCompleted != 4){return nextTopic};
    }).filter((element:any) => {return (element)});
    if(selectedTopic) {this.setLocalStorageForTopics(selectedTopic);}
    else{alert('All Topics Completed')}
  }
  isLastTopic(){
    const currentTopicId = this.selfLearnService.getTopicId();
    let nextTopic;
    const selectedTopic = this.tabPracticeTopicData.map((topic:any,row:any) => {
      nextTopic = this.tabPracticeTopicData[row+1]
        if(topic.topicId == currentTopicId && nextTopic.levelsCompleted != 4){return nextTopic};
      }).filter((element:any) => {return (element)});
      if(selectedTopic.length>0){
        return false
      }else{
        return true;
      }
  }

  setLocalStorageForTopics(selectedTopic:any){
    localStorage.setItem("selfLearnSelectedTopicId", selectedTopic[0].topicId);
    localStorage.setItem("selfLearnSelectedTopicName", selectedTopic[0].topicName);
    localStorage.setItem('currentLevel', selectedTopic[0].levelsInProgress);
    localStorage.setItem('subtopicCount', selectedTopic[0].subtopicCount);
    this.router.navigateByUrl("selfLearn-V2/practice-questions");
  }

  navigateToPracticeQuestions(){
    this.setTopicAndNavigateToPracticeQuestions();
  }


  renderDonutChart(){
    this.donutchartOptions1 = {
      series: [this.practiceAnalysis?.correct, this.practiceAnalysis?.notAnswered, this.practiceAnalysis?.inCorrect],
      labels: ['Correct', 'Not answered','Incorrect'],
      chart: {
        height: 130,
        width: '100%',
        type: 'donut',
        background: 'transparent',
        offsetX: 0,
        offsetY: 0,
      },
      dataLabels: {
        enabled: false,
      },
      plotOptions: {
        pie: {
        donut: {
          labels: {
            show: true,
            name: {
              show: true,
              fontSize: '14px',
              fontFamily: 'Montserrat',
              color: '#A0A3BD',
              offsetY: 0
            },
            value: {
              show: true,
              fontSize: '16px',
              fontFamily: 'Montserrat',
              color: undefined,
              offsetY: 0,
              formatter: function (val:any) {
                return val
              }
            },
            total: {
              show: true,
              fontSize: '12px',
              fontFamily: 'Montserrat',
              label: 'Accuracy',
              color: '#A0A3BD',
              formatter: function (w:any) {
                return Math.round((w.globals.seriesTotals[0] / w.globals.seriesTotals.reduce((a:any, b:any) => {
                  return a + b
                }, 0)) * 100) + '%';
              }
            }
          }
        }
      }
      },
      fill: {
        colors: ['#00BA88', '#A0A3BD', '#B7295A']
      },
      stroke: {
        width: 0,
      },
      legend: {
        show: false,
      },
      states: {
        hover: {
          filter: {
            type: 'none',
          }
        },
      },
      tooltip: {
        enabled: false,
      },
      responsive: [
        {
          breakpoint: 330,
          options: {
            chart: {
              height: 115,
            },
            plotOptions: {
              pie: {
                donut: {
                  labels: {
                    show: true,
                    name: {
                      show: true,
                      fontSize: '12px',
                      fontFamily: 'Montserrat',
                      color: '#A0A3BD',
                      offsetY: 0
                    },
                    value: {
                      show: true,
                      fontSize: '12px',
                      fontFamily: 'Montserrat',
                      color: undefined,
                      offsetY: -5,
                    },
                    total: {
                      show: true,
                      fontSize: '10px',
                      fontFamily: 'Montserrat',
                      label: 'Accuracy',
                      color: '#A0A3BD',
                    }
                  }
                }
              }
            },
          }
        }
      ]
    };
  }

}
